export default __webpack_public_path__ + "static/media/icon_carousel_arrow.688935f1.svg";